import { render, staticRenderFns } from "./FormUploadFile.vue?vue&type=template&id=9d78715a&"
import script from "./FormUploadFile.vue?vue&type=script&lang=ts&"
export * from "./FormUploadFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports